
import { Company } from "@/models/company";
import { CompanyVars } from "@/models/company-vars";
import { CompanyService } from "@/services/company-service";
import AppLabel from "@/components/LabelWithValue.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			vars: new CompanyVars()
		};
	},
	props: {
		value: {
			type: Object as ()=>Company,
			required: true
		}
	},
	watch: {
		"value.id": {
			immediate: true,
			handler(){
				this.fetch();
			}
		}
	},
	methods: {
		getBoolValue(val:boolean):string{
			if (val){
				return "Ja";
			}
			return "Nee";
		},
		async fetch(){
			if (this.value.id == 0) return;
			this.vars = await CompanyService.getVars(this.value);
		}
	},
	components: {
		AppLabel
	}
});
